/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymarketCompanyJobEligibilityField {
    COMPANY_JOB_SUB_FAMILY = 'companyJobSubFamily',
    COMPANY_JOB_LEVEL = 'companyJobLevel',
    JOB_ELIGIBILITY1 = 'jobEligibility1',
    JOB_ELIGIBILITY2 = 'jobEligibility2',
    JOB_ELIGIBILITY3 = 'jobEligibility3',
    GLOBAL = 'global',
    JOB_POINTS = 'jobPoints',
}
